<template>
  <div class="alert alert-success alert-dismissible fade show" v-if="this.referral.code" role="alert">
    <span v-if="this.referral.referrer">
      Referral Code from <strong>{{ this.referral.referrer }}</strong> has been applied.
    </span>
    <span v-if="!this.referral.referrer">
      Referral Code <strong>{{ this.referral.code }}</strong> has been applied.
    </span>
  </div>
</template>

<script>
export default {
  name: 'CheckoutReferralNotification',
  props: ['referral']
};
</script>
